import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div<{ size?: number }>`
  width: ${(p) => p.size ?? 20}px;
  height: ${(p) => p.size ?? 20}px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid ${(p) => p.theme.badge.background};
  border-top-color: ${(p) => p.theme.color.palette.cornflowerBlue};
  animation: ${spin} 0.8s linear infinite;
  flex-shrink: 0;
`;
